import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class CompanyDocumentService {
  private readonly baseUrl = environment.apiUrl + 'company-documents';

  constructor(private http: HttpClient) {}

  getAll() { return this.http.get<any[]>(this.baseUrl); }
  upload(file: File, documentType: string, notes: string) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('documentType', documentType);
    formData.append('notes', notes || '');
    return this.http.post(this.baseUrl + '/upload', formData);
  }
  toggle(id: string) { return this.http.put(this.baseUrl + '/' + id + '/toggle', {}); }
  delete(id: string) { return this.http.delete(this.baseUrl + '/' + id); }
}
